import cn from "classnames";
import { searchFilterStore } from "entities/SearchFilter";
import { ShipmentTypeChecker } from "entities/shared/utils";
import { useAppSelector } from "shared/lib/redux";
import { localization, useTranslation } from "shared/localization/localization";
import { Link } from "shared/ui/Button";
import { SIGN_IN_URL } from "shared/utils/url.utils";
import styles from "./UpgradeButton.module.scss";

type UpgradeButtonProps = {
  className?: string;
};

/**
 * Guest-only call to action, shown on our own site.
 *
 * It used to open AuthModal, which is commented out of Modals and whose
 * component is a stub - so the button did nothing at all. The sign-in page is
 * what that modal stood in for, and it is where the limit notice sends people
 * as well, so the button goes there directly.
 */
export const UpgradeButton: RFC<UpgradeButtonProps> = ({ className }) => {
  const { t } = useTranslation();
  const shipmentType = useAppSelector(searchFilterStore.selectors.shipment);
  const isShipmentTypeConfirmed = useAppSelector(searchFilterStore.selectors.isShipmentTypeConfirmed);
  const isGlobalTracking = useAppSelector(searchFilterStore.selectors.isGlobalTracking);
  const isGlobalUpgrade = isGlobalTracking && !isShipmentTypeConfirmed;
  const isAirUpgrade = isShipmentTypeConfirmed && ShipmentTypeChecker.isAir(shipmentType);

  return (
    <></>
    //   href={SIGN_IN_URL(localization.language)}
    //   className={cn(
    //     styles.upgradeBtn,
    //     isGlobalUpgrade && styles.upgradeBtnGlobal,
    //     isAirUpgrade && styles.upgradeBtnAir,
    //     !isGlobalUpgrade && !isAirUpgrade && styles.upgradeBtnSea,
    //     className
    //   )}
    //   data-test-id="payments-button-upgrade"
    // >
    //   {t("Upgrade")}
    // </Link>
  );
};
